// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.soresu-attachment-block {
  display: block;
  width: 800px;
  padding-top: 10px;
  padding-bottom: 14px;
  border-bottom: 1px solid #d9d9d9;
}
div.soresu-attachment-block:nth-child(1) {
  border-top: 1px solid #d9d9d9;
  margin-top: 6px;
}
div.soresu-attachment-block label {
  margin: 0;
}
div.soresu-attachment-display {
  display: block;
}
div.soresu-attachment-display a {
  text-decoration: none;
}
div.soresu-attachment-display span {
  color: #999290;
}
div.soresu-attachment-display button.soresu-remove {
  position: relative;
  top: 6px;
  left: 20px;
}
.soresu-attachment-missing {
  display: inline;
  color: #999290;
}
.soresu-preview .soresu-key {
  color: #4a4a4a;
  font-weight: 400;
  display: block;
  padding: 10px 10px 3px 0;
}
.soresu-preview .soresu-value {
  color: #1a1919;
  font-size: 18px;
}
.soresu-preview .soresu-preview-element.extra-extra-small {
  width: 100px;
}
.soresu-preview .soresu-preview-element.extra-small {
  width: 200px;
}
.soresu-preview .soresu-preview-element.small {
  width: 267px;
}
.soresu-preview .soresu-preview-element.medium {
  width: 400px;
}
.soresu-preview .soresu-preview-element.large {
  width: 534px;
}
@media print {
  .soresu-preview .soresu-preview-element.large {
    width: 400px;
  }
}
.soresu-preview .soresu-preview-element.extra-large {
  width: 800px;
}
.soresu-preview .soresu-preview-element .soresu-money:after {
  content: "\\00A0€";
}
.soresu-preview .soresu-text-area.extra-extra-small,
.soresu-preview .soresu-text-area.extra-small,
.soresu-preview .soresu-text-area.small,
.soresu-preview .soresu-text-area.medium,
.soresu-preview .soresu-text-area.large,
.soresu-preview .soresu-text-area.extra-large {
  width: 800px;
  text-align: justify;
}
.soresu-preview .soresu-preview-fieldset div.extra-large,
.soresu-preview .soresu-preview-growing-fieldset div.extra-large {
  display: block;
}
.soresu-preview .soresu-preview-fieldset .soresu-preview-element,
.soresu-preview .soresu-preview-growing-fieldset .soresu-preview-element {
  display: inline-block;
}
.soresu-preview .soresu-preview-fieldset .hidden,
.soresu-preview .soresu-preview-growing-fieldset .hidden {
  display: none;
}
.soresu-preview .soresu-preview-growing-fieldset ol {
  margin: 20px 0 0 -56px;
  list-style-type: none;
  counter-reset: item;
}
.soresu-preview .soresu-preview-growing-fieldset ol li:before {
  content: counter(item) "  ";
  counter-increment: item;
  float: left;
  width: 1em;
  font-weight: 600;
}
.soresu-preview .soresu-preview-growing-fieldset ol li.soresu-preview-growing-fieldset-child {
  margin: 0 0 10px 0;
}
.soresu-preview .soresu-preview-growing-fieldset ol li.soresu-preview-growing-fieldset-child > * {
  margin-left: 15px;
}
.soresu-preview .soresu-preview-growing-fieldset.show-only-first-label ol li:first-child:before {
  margin-top: 22px;
}
`, "",{"version":3,"sources":["webpack://./soresu-form/web/form/style/preview.less"],"names":[],"mappings":"AAEA;EACE,cAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;EACA,gCAAA;AADF;AAGE;EACE,6BAAA;EACA,eAAA;AADJ;AARA;EAaI,SAAA;AAFJ;AAMA;EACE,cAAA;AAJF;AAGA;EAGI,qBAAA;AAHJ;AAAA;EAMI,cAAA;AAHJ;AAHA;EASI,kBAAA;EACA,QAAA;EACA,UAAA;AAHJ;AAOA;EACE,eAAA;EACA,cAAA;AALF;AAQA;EAEI,cAAA;EACA,gBAAA;EACA,cAAA;EACA,wBAAA;AAPJ;AAEA;EASI,cAAA;EACA,eAAA;AARJ;AAYI;EACE,YAAA;AAVN;AAYI;EACE,YAAA;AAVN;AAYI;EACE,YAAA;AAVN;AAYI;EACE,YAAA;AAVN;AAYI;EACE,YAAA;AAVN;AAYM;EAAA;IACE,YAAA;EATN;AACF;AAWI;EACE,YAAA;AATN;AAaM;EACE,iBAAA;AAXR;AAiBI;;;;;;EACE,YAAA;EACA,mBAAA;AAVN;AArCA;;EAqDM,cAAA;AAZN;AAzCA;;EAyDM,qBAAA;AAZN;AA7CA;;EA6DM,aAAA;AAZN;AAjDA;EAmEM,sBAAA;EACA,qBAAA;EACA,mBAAA;AAfN;AAtDA;EAwEQ,2BAAA;EACA,uBAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;AAfR;AA7DA;EAgFQ,kBAAA;AAhBR;AAhEA;EAkFU,iBAAA;AAfV;AAoBI;EAEI,gBAAA;AAnBR","sourcesContent":["@import \"variables\";\n\ndiv.soresu-attachment-block {\n  display: block;\n  width: @section-width;\n  padding-top: 10px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid @light-gray;\n\n  &:nth-child(1) {\n    border-top: 1px solid @light-gray;\n    margin-top: 6px;\n  }\n\n  label {\n    margin: 0;\n  }\n}\n\ndiv.soresu-attachment-display {\n  display: block;\n  a {\n    text-decoration: none;\n  }\n  span {\n    color: @dark-gray;\n  }\n  button.soresu-remove {\n    position: relative;\n    top: 6px;\n    left: 20px;\n  }\n}\n\n.soresu-attachment-missing {\n  display: inline;\n  color: @dark-gray;\n}\n\n.soresu-preview {\n  .soresu-key {\n    color: @form-label-black;\n    font-weight: 400;\n    display: block;\n    padding: 10px 10px 3px 0;\n  }\n\n  .soresu-value {\n    color: @text-black;\n    font-size: 18px;\n  }\n\n  .soresu-preview-element {\n    &.extra-extra-small {\n      width: ceil((@section-width / 8));\n    }\n    &.extra-small {\n      width: ceil((@section-width / 4));\n    }\n    &.small {\n      width: ceil((@section-width / 3));\n    }\n    &.medium {\n      width: ceil((@section-width / 2));\n    }\n    &.large {\n      width: ceil((@section-width / 1.5));\n\n      @media print {\n        width: 400px;\n      }\n    }\n    &.extra-large {\n      width: @section-width;\n    }\n\n    .soresu-money {\n      &:after {\n        content: \"\\00A0€\"\n      }\n    }\n  }\n\n  .soresu-text-area {\n    &.extra-extra-small, &.extra-small, &.small, &.medium, &.large, &.extra-large {\n      width: @section-width;\n      text-align: justify;\n    }\n  }\n  .soresu-preview-fieldset,  .soresu-preview-growing-fieldset {\n\n    div.extra-large {\n      display: block;\n    }\n\n    .soresu-preview-element {\n      display: inline-block;\n    }\n\n    .hidden {\n      display: none;\n    }\n  }\n\n  .soresu-preview-growing-fieldset {\n    ol {\n      margin: 20px 0 0 -56px;\n      list-style-type: none;\n      counter-reset: item;\n\n      li:before {\n        content: counter(item) \"  \";\n        counter-increment: item;\n        float: left;\n        width: 1em;\n        font-weight: 600;\n      }\n\n      li.soresu-preview-growing-fieldset-child {\n        margin: 0 0 10px 0;\n        > * {\n          margin-left: 15px;\n        }\n      }\n    }\n\n    &.show-only-first-label ol {\n      li:first-child:before {\n        margin-top: 22px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
